module.exports = __webpack_public_path__ + "img/menu-banner.70892bf.png";